/**
 *
 * @module billingAddress
 *
 */

import Check from 'check-types';

import InvalidArgumentException from './../exception/invalidArgumentException';

const {
    nonEmptyString,
    nonEmptyObject
} = Check.assert;

/**
 *
 * @class BillingAddress
 *
 */
export default class BillingAddress {

    /**
     *
     * @param {Object} options
     * @param {String} [options.line1=undefined]
     * @param {String} [options.line2=undefined]
     * @param {String} [options.line3=undefined]
     * @param {String} [options.city=undefined]
     * @param {String} [options.state=undefined]
     * @param {String} options.country
     * @param {String} [options.postalCode=undefined]
     * @throws {InvalidArgumentException}
     * @note currently for NL launch only country is required
     *
     */
    constructor(options = {}) {

        const errorMessage = {
            ctor: 'BillingAddress(options)',
            get options() {
                return `${this.ctor} options should be a non-empty Object`;
            },
            get line1() {
                return `${this.ctor} line1 should be a non-empty String`;
            },
            get line2() {
                return `${this.ctor} line2 should be a non-empty String`;
            },
            get line3() {
                return `${this.ctor} line3 should be a non-empty String`;
            },
            get city() {
                return `${this.ctor} city should be a non-empty String`;
            },
            get state() {
                return `${this.ctor} state should be a non-empty String`;
            },
            get country() {
                return `${this.ctor} country should be a non-empty String`;
            },
            get postalCode() {
                return `${this.ctor} postalCode should be a non-empty String`;
            }
        };

        nonEmptyObject(options, errorMessage.options, InvalidArgumentException);

        const { line1, line2, line3, city, state, country, postalCode } = options;

        if (Check.assigned(line1)) {
            nonEmptyString(line1, errorMessage.line1, InvalidArgumentException);
        }

        if (Check.assigned(line2)) {
            nonEmptyString(line2, errorMessage.line2, InvalidArgumentException);
        }

        if (Check.assigned(line3)) {
            nonEmptyString(line3, errorMessage.line3, InvalidArgumentException);
        }

        if (Check.assigned(city)) {
            nonEmptyString(city, errorMessage.city, InvalidArgumentException);
        }

        if (Check.assigned(state)) {
            nonEmptyString(state, errorMessage.state, InvalidArgumentException);
        }

        if (Check.assigned(postalCode)) {
            nonEmptyString(postalCode, errorMessage.postalCode, InvalidArgumentException);
        }

        nonEmptyString(country, errorMessage.country, InvalidArgumentException);

        /**
         *
         * @access public
         * @type {String|undefined}
         *
         */
        this.line1 = line1;

        /**
         *
         * @access public
         * @type {String|undefined}
         *
         */
        this.line2 = line2;

        /**
         *
         * @access public
         * @type {String|undefined}
         *
         */
        this.line3 = line3;

        /**
         *
         * @access public
         * @type {String|undefined}
         * @desc City. Required for select regions, optional otherwise.
         *
         */
        this.city = city;

        /**
         *
         * @access public
         * @type {String|undefined}
         * @desc State / County / Province / Region. Required for select regions, optional otherwise.
         *
         */
        this.state = state;

        /**
         *
         * @access public
         * @type {String}
         * @desc Country. See ISO 3166-1 alpha-2 for format
         *
         */
        this.country = country;

        /**
         *
         * @access public
         * @type {String|undefined}
         * @desc ZIP or postal code. Required for select regions, optional otherwise.
         *
         */
        this.postalCode = postalCode;

    }

}



// WEBPACK FOOTER //
// ./src/services/commerce/billingAddress.js